import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ListManagementCostHead, AddManagementCosts, ListManagementCost } from "../store/slices/management-cost.js";
import { GetPaymentMethods } from "../store/slices/sale";
import { useDispatch, useSelector } from "react-redux";
import { toast } from 'react-hot-toast';
import Loader from "../common/Loader";
import AdminLayout from "./AdminLayout";

const AddManagementCost = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [costRows, setCostRows] = useState([]);
  const [filesByHead, setFilesByHead] = useState({});
  const user = JSON.parse(localStorage.getItem("user"));
  const id = user?.data?.profile_id;

  const [headingLabel, setHeadingLabel] = useState('Management Cost Date');

  const parseAmount = (value) => {
    const num = Number(value);
    return Number.isFinite(num) ? num : 0;
  };

  const totalApplied = costRows.reduce((sum, row) => sum + parseAmount(row.amount), 0);
  const totalReceived = costRows.reduce((sum, row) => sum + parseAmount(row.received_amount), 0);

  const resolveFileUrl = (fileName) => {
    if (!fileName) return '';
    if (/^https?:\/\//i.test(fileName)) return fileName;
    return `http://api.kisaankhata.com/management-cost/download/${encodeURIComponent(fileName)}`;
  };



  const handleTableChange = (index, field, value) => {
    setCostRows((prev) => {
      const next = [...prev];
      next[index] = { ...next[index], [field]: value };
      return next;
    });
  };


  useEffect(() => {
    if (!id) return;
    setIsLoading(true);
    dispatch(ListManagementCostHead({ profile_id: id }))
      .then((action) => {
        const res = action.payload || action;
        const list = res?.data || res?.result || res || [];
        const heads = Array.isArray(list) ? list : list.data || []
        // initialize editable rows from heads
        const rows = heads.map((h) => ({
          cost_head_id: h.id,
          name: h.head_name || h.name || "",
          amount: h.amount || "",
          file: null,
          file_name: h.file_name || "",
          received_amount: h.received_amount || "",
        }));
        setCostRows(rows);
        // fetch existing management cost entries to compute next sequence number for heading
        dispatch(ListManagementCost({ profile_id: id }))
          .then((act) => {
            const r = act.payload || act;
            const l = r?.data || r?.result || r || [];
            const items = Array.isArray(l) ? l : l.data || [];
            const nextIndex = (items?.length || 0) + 1;
            setHeadingLabel(`Management Cost -${nextIndex}`);
          })
          .catch(() => {
            setHeadingLabel('Management Cost -1');
          });
      })
      .catch(() => {})
      .finally(() => setIsLoading(false));
  }, [dispatch, id]);

  const handleFileChange = (headId, selectedFiles) => {
    setFilesByHead((prev) => ({
      ...prev,
      [headId]: selectedFiles,
    }));
  };

  const handleSubmit = (e) => {
    e?.preventDefault?.();
    if (!id) return;
    setIsLoading(true);
    const fd = new FormData();
    fd.append("profile_id", id);
    // include the dynamic heading label so backend can record the sequence label
    fd.append("phase", headingLabel);
    // append parallel arrays: cost_head_id[], amount[], file_name[] and files[]
    costRows.forEach((r) => {
      fd.append("cost_head_id[]", r.cost_head_id);
      fd.append("applied_amount[]", r.amount || "0");
      fd.append("received_amount[]", r.received_amount || "0");
      const selectedFiles = filesByHead[r.cost_head_id];
      if (selectedFiles && selectedFiles.length > 0) {
        Array.from(selectedFiles).forEach((file) => {
          fd.append(`file_name[${r.cost_head_id}][]`, file);
        });
      }
    });

    dispatch(AddManagementCosts(fd))
      .then((action) => {
        const res = action.payload || action;
        console.log("AddManagementCosts response", res);
        const ok = res && (
          res.status === true ||
          res.status === 'success' ||
          res.success === true ||
          res.code === 201 ||
          res.statusCode === 201 ||
          (res.data && (res.data.status === true || res.data.success === true))
        );
        if (ok) {
          toast.success(res?.message || 'Management cost added');
          navigate('/management-cost/list');
        } else {
          toast.error(res?.message || 'Failed to add management cost');
        }
      })
      .catch((err) => {
        console.error('AddManagementCosts error', err);
        toast.error('Failed to add management cost');
      })
      .finally(() => setIsLoading(false));
  };

  const handleDiscard = () => {
    navigate(-1);
  };

 

  return (
    <AdminLayout>
      {isLoading && <Loader />}
      <div className="row content-body ">
        <div className="container">
          <div className="page-header">
            <div>
              <h2 class="main-content-title tx-24 mg-b-5">Management Cost</h2>

              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="#">Registers</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">
                  Add Management Cost
                </li>
              </ol>
            </div>
          </div>
          <div class="row mb-5">
            <div class="col-md-10">
              <div class="card custom-card">
                <div class="card-body">
                  <div className="row mb-3">
                    <div className="col-md-4">
                      <label
                        style={{ fontWeight: 700, fontSize: "20px" }}
                      >
                        {headingLabel}
                      </label>
                    </div>
                  </div>
                  <div className="mb-3">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th style={{ width: "5%" }}>SR</th>
                          <th>Name</th>
                          <th>Applied Amount</th>
                          <th>Received Amount</th>
                          <th>File</th>
                          <th>File Download</th>
                        </tr>
                      </thead>
                      <tbody>
                        {costRows.map((it, idx) => (
                          <tr key={idx}>
                            <td>{idx + 1}</td>
                            <td>
                              <div className="form-control-plaintext">{it.name || ''}</div>
                            </td>
                            <td>
                              <div className="input-group">
                                <span className="input-group-text">₹</span>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={it.amount}
                                  onChange={(e) =>
                                    handleTableChange(
                                      idx,
                                      "amount",
                                      e.target.value,
                                    )
                                  }
                                />
                              </div>
                            </td>
                            <td>
                              <div className="input-group">
                                <span className="input-group-text">₹</span>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={it.received_amount || ''}
                                  onChange={(e) =>
                                    handleTableChange(
                                      idx,
                                      'received_amount',
                                      e.target.value,
                                    )
                                  }
                                />
                              </div>
                            </td>
                            <td>
                              <input
                                type="file"
                                multiple
                                name={`file_name[${it.cost_head_id}][]`}
                                className="form-control"
                                onChange={(e) =>
                                  handleFileChange(it.cost_head_id, e.target.files)
                                }
                              />
                            </td>
                            <td>
                              <button
                                type="button"
                                className="btn btn-link p-0"
                                disabled={!resolveFileUrl(it.file_name)}
                                onClick={() => {
                                  const url = resolveFileUrl(it.file_name);
                                  if (url) window.open(url, '_blank', 'noreferrer');
                                }}
                              >
                                Download
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colSpan={2} style={{ fontWeight: 600 }}>Total</td>
                          <td style={{ fontWeight: 600 }}>₹ {totalApplied.toFixed(2)}</td>
                          <td style={{ fontWeight: 600 }}>₹ {totalReceived.toFixed(2)}</td>
                          <td colSpan={2}></td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>

                  <div class="form-group">
                    <div class="row" style={{ textAlign: "right", paddingTop: "20px" }}>
                      <div class="col-md-12">
                        <button
                          type="button"
                          class="btn btn-default"
                          onClick={handleSubmit}
                        >
                          Submit
                        </button>
                        &nbsp;
                        <button
                          type="button"
                          class="btn btn-cancel"
                          onClick={handleDiscard}
                        >
                          Cancel
                        </button>
                        &nbsp;
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AddManagementCost;
